import { api } from "../api";
import { ptDlDo } from "./download";
import { toastSuccess } from "../ui/messages";
import { getDomElement, setHtml, fadeIn, fadeOut, hide } from "../utils/dom";
import { ID_DOWNLOAD_CART_COUNT } from "../utils/elementIds";
import { mountDownloadCart } from "./components/DownloadCart";
import { updateDownloadStatus } from "./cart";

function updateCartCount(delta: number): void {
  const countEl = getDomElement(ID_DOWNLOAD_CART_COUNT);
  if (!countEl) throw new Error("Element not found: #download-cart-count");
  let count = parseInt(countEl.innerHTML ?? "0") + delta;

  if (count <= 0) {
    count = 0;
    fadeOut("download-cart");
    fadeOut("download-cart-button");
    hide("download-cart-back");
  } else {
    fadeIn("download-cart-button");
  }
  countEl.innerHTML = String(count);
}

export async function addDownloadCart(id: string): Promise<void> {
  let response: { added: boolean };
  try {
    response = await api.downloadCart.toggle({ id: Number(id) });
  } catch (err: unknown) {
    alert((err as Error).message);
    return;
  }

  if (response.added) {
    toastSuccess("Added artwork to downloader");
    setHtml("overlay-dlcart" + id, '<i class="fa fa-download"></i> Remove');
    setHtml("view-dlcart-" + id, '<i class="fas fa-download"></i> Remove');
    updateCartCount(1);
    void refreshDownloadCartIfVisible();
  } else {
    toastSuccess("Removed artwork from downloader");
    setHtml("overlay-dlcart" + id, '<i class="fa fa-download"></i> Download');
    setHtml("view-dlcart-" + id, '<i class="fas fa-download"></i> Download');
    restoreDownloadButtons(id);
    updateCartCount(-1);
    void refreshDownloadCartIfVisible();
  }
}

function restoreDownloadButtons(id: string): void {
  const container = getDomElement(`view-download-buttons-${id}`);
  if (!container) return;
  container.innerHTML =
    '<span class="view-download-label">DOWNLOAD</span> ' +
    `<span class="button small yellow dlbuttonfix add-cart-btn"><i class="fas fa-plus"></i> Later</span> &nbsp; ` +
    `<span class="buttom small green dlbuttonfix quick-dl-btn" id="overlay-dlcart2${id}"><i class="fas fa-download"></i> Quick</span>`;
  bindDownloadBtns(id);
}

function inDlcHtml(id: string): string {
  return (
    '<span style="font-size: 0.7em; font-weight: 400;"><i>Artwork added to download cart</i></span> &nbsp; ' +
    `<span class="button small dlbuttonfix remove-cart-btn" style="background:#c0392b;color:#fff;font-size:0.7em;" data-id="${id}"><i class="fas fa-times"></i> Remove</span>`
  );
}

export async function addDownloadCart2(id: string): Promise<void> {
  let response: { added: boolean };
  try {
    response = await api.downloadCart.toggle({ id: Number(id) });
  } catch (err: unknown) {
    alert((err as Error).message);
    return;
  }

  if (response.added) {
    toastSuccess("Added artwork to downloader");
    setHtml("view-download-buttons-" + id, inDlcHtml(id));
    bindRemoveCartBtn(id);
    updateCartCount(1);
    void refreshDownloadCartIfVisible();
  } else {
    toastSuccess("Removed artwork from downloader");
    setHtml("overlay-dlcart" + id, '<i class="fa fa-download"></i> Download');
    setHtml("view-dlcart-" + id, '<i class="fas fa-download"></i> Download');
    updateCartCount(-1);
    void refreshDownloadCartIfVisible();
  }
}

export async function removeFromDownloadCart2(id: string): Promise<void> {
  const response = await api.downloadCart.toggle({ id: Number(id) });

  if (!response.added) {
    toastSuccess("Removed artwork from downloader");
    restoreDownloadButtons(id);
    updateCartCount(-1);
    void refreshDownloadCartIfVisible();
  }
}

function bindRemoveCartBtn(id: string): void {
  const container = getDomElement(`view-download-buttons-${id}`);
  container?.querySelector(".remove-cart-btn")?.addEventListener("click", (e) => {
    e.stopPropagation();
    void removeFromDownloadCart2(id);
  });
}

function bindDownloadBtns(id: string): void {
  const container = getDomElement(`view-download-buttons-${id}`);
  container?.querySelector(".add-cart-btn")?.addEventListener("click", (e) => {
    e.stopPropagation();
    void addDownloadCart2(id);
  });
  container?.querySelector(".quick-dl-btn")?.addEventListener("click", (e) => {
    e.stopPropagation();
    void ptDlDo(id);
  });
}

async function refreshDownloadCartIfVisible(): Promise<void> {
  if (getDomElement("download-cart")?.style.display !== "block") return;
  try {
    const response = await api.downloadCart.getCart();
    mountDownloadCart(response);
  } catch {
    // ignore
  }
}

export async function download(id: string): Promise<void> {
  try {
    await api.downloadCart.download({
      id: id
        .split(",")
        .map(Number)
        .filter((n) => n > 0),
    });
    toastSuccess("Your download is being prepared. Please wait.");

    const response2 = await api.downloadCart.getCart();
    mountDownloadCart(response2);

    if (response2.state === "downloading") {
      void updateDownloadStatus();
    }
  } catch (err: unknown) {
    alert((err as Error).message);
  }
}

export { bindRemoveCartBtn };
